import React from 'react';
import ReactJson, { ReactJsonViewProps } from 'react-json-view';
import { FieldProps, useRecordContext, useTheme } from 'react-admin';

type Props = {
  source: string;
  jsonString?: boolean;
  reactJsonOptions?: Omit<ReactJsonViewProps, 'src'>;
} & FieldProps;

export const JsonField: React.FC<Props> = ({ source, jsonString = false, reactJsonOptions = {} }) => {
  const record = useRecordContext();
  const [theme] = useTheme();

  const { style: customStyles, ...reactJsonOverrides } = reactJsonOptions ?? {};

  if (!record) return null;

  let src = record[source];

  if (jsonString) {
    src = JSON.parse(src);
  }

  const finalStyles: ReactJsonViewProps['style'] = {
    ...(theme === 'light' && {
      backgroundColor: '#F9F9F9',
    }),
    ...customStyles,
  };

  return (
    <ReactJson
      {...reactJsonOverrides}
      style={finalStyles}
      theme={theme === 'dark' ? 'ocean' : 'rjv-default'}
      src={src || {}}
    />
  );
};
